import { useState } from 'react';
import { loadScript } from 'utils/browser.js';
import { isProduction } from 'constants/gcp.js';

const isCoreDomain = () => {
  return !!window.location.host.match(/^([a-zA-Z0-9_-]+\.)?bambuser\.com$/) ||
  !!window.location.host.match(/^([a-zA-Z0-9_-]+\.)?codemines\.org(:\d+)?$/);
};

let loadingPromise;
const getLib = () => {
  if (!loadingPromise) {
    const url = (() => {
      if (isCoreDomain()) {
        // Use the "next" release in development, "latest" in production
        const release = isProduction ? 'latest' : 'next';
        return `https://cdn.bambuser.net/player/lib/bambuser-video-core/${release}/bambuser-video-core.min.js`;
      }

      // Fallback: use the iframe wrapped player for non-core domains to avoid CORS restrictions
      return 'https://cdn.bambuser.net/player/lib/bambuser-video-iframeapi/latest/bambuser-video-iframeapi.min.js';
    })();
    loadingPromise = loadScript(url);
  }
  return loadingPromise;
};

const useBaaSPlayerLib = () => {
  const [lib, setLib] = useState(undefined);

  getLib().then(() => {
    setLib(window.BambuserVideo || window.BambuserPlayer);
  });

  return lib;
};

export default useBaaSPlayerLib;
